module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/common/icon_train-f20ea2020c011fa2738aedceb0c10b08.svg";